<template>
  <div class="topList_bar">
    <div class="barList_main">
      <span
        class="barList_item"
        v-for="item in testData"
        :key="item.id"
        :style="{
          width: `${item.width}%`,
          top: `${item.top}vw`,
          zIndex: `${item.zIndex}`,
          backgroundColor: `${item.bgColor}`,
        }"
      ></span>
    </div>
  </div>
</template>

<script>
// 特效：横向动态bar效果
export default {
  name: 'topList_bar',
  data() {
    return {
      testData: [
        {
          id: 1,
          width: 60,
          top: 2,
          zIndex: 10,
          bgColor: 'blue',
        },
        {
          id: 2,
          width: 40,
          top: 0,
          zIndex: 9,
          bgColor: 'red',
        },
      ],
    }
  },
  created() {
    setTimeout(() => {
      this.testData = [
        {
          id: 1,
          width: 40,
          top: 0,
          zIndex: 10,
          bgColor: 'blue',
        },
        {
          id: 2,
          width: 60,
          top: 2,
          zIndex: 9,
          bgColor: 'red',
        },
      ]
    }, 5 * 1000)
  },
}
</script>

<style lang="scss" scoped>
.topList_bar {
  width: 100%;
  height: auto;
  .barList_main {
    position: relative;
    width: 100%;
    height: auto;
    max-height: 6.94vw;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    .barList_item {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 20;
      width: 50%;
      background-color: red;
      border-radius: 0.694vw;
      height: 1.4vw;
      margin: 0.3vw 0;
      transition: all 0.3s linear;
    }
  }
}
</style>
